<template>
  <v-layout>
    <div class="padding-container-sm">
      <b-card-group
        deck
        class="mb-3"
      >
        <b-card
          v-for="(statusCount,index) in patientStatusCount"
          :key="index"
          bg-variant="primary"
          :header="statusCount.status"
          :class="statusCount.status"
          class="text-center"
        >
          <h2>{{ statusCount.count }}</h2>
        </b-card>
      </b-card-group>
        <div class="border-bottom mb-3 pb-2 row">
          <div class="col-8">
            <div class="row">

            <div class="col-8">
              <b-input-group size="md">
                <b-input-group-text
                  slot="append"
                  class="bg-white"
                >
                  <strong><i class="icon ion-md-search" /></strong>
                </b-input-group-text>
                <b-form-input
                  class="border-right-0"
                  :value="filter.searchValue"
                  placeholder="Search for patient name or ID in Patient list"
                  @keyup.enter.native="onSearchText"
                  @blur.native="onSearchText"
                />
              </b-input-group>
            </div>
            <div class="col col-4">
              <button
                type="button"
                class="btn btn-outline-primary btn-block"
                @click="addPatient"
              >
                <i class="icon ion-md-add" />
                Add Patient
              </button>
            </div>
            </div>
          </div>
        <div
          v-if="patientStatusCount"
          class="col-4"
        >
          <span
            v-for="(statusCount,index) in patientStatusCount"
            :key="index"
            class="status-count-content"
            :class="{active : statusCount.status === filter.status}"
            @click="setStatus(statusCount.status)"
          >
            <span
              class="btn btn-link"
              :class="{disabled : statusCount.status === filter.status, [statusCount.status]: true}"
            >{{ statusCount.status | capitalizefirst }}</span>
            <span class="count">({{ statusCount.count }})</span>
          </span>
        </div>
        </div>
      <v-table
        :options="tableProps"
        :total-count="totalCount"
        :loading="loading"
        :data="patientList"
      >
        <template
          slot="patientName"
          slot-scope="slotProps"
        >
          <div class="align-items-center d-flex patient-name-content">
            <img
              :src="require(`@/assets/image/${slotProps.data.datum.user.gender === 'male'
                ? 'boy': 'girl'}.svg`)"
              width="35"
              height="35"
              :alt="slotProps.data.datum.user.first_name"
              v-b-tooltip.hover
              :title="slotProps.data.datum.user.first_name"
            >
            <div
              class="d-flex flex-column justify-content-center"
              v-if="slotProps"
            >
              <span
                class="text-center btn btn-link"
                @click="viewEHR(slotProps.data.datum.id)"
              >
                {{ slotProps.data.datum.user.first_name | capitalizefirst }}
                {{ slotProps.data.datum.user.last_name | capitalizefirst }}
              </span>
              <span  v-if="permissions.patientmessage && permissions.patientmessage.view" class="btn btn-link" @click="redirectToMessage(slotProps.data.datum.mr_id)">
                Send Message
              </span>
            </div>
          </div>
        </template>
        <template
          slot="status"
          slot-scope="slotProps"
        >
          <div
            v-if="slotProps"
            class="d-flex flex-column justify-content-between align-items-center p-2"
          >
            <span :class="slotProps.data.datum.status.toLowerCase()">
              <span>
                <h2>{{ slotProps.data.datum.status.substring(0, 1) }}</h2>
              </span><b>{{ slotProps.data.datum.status.substring(1).toLowerCase() }}</b>
            </span>
            <span
              v-if="!slotProps.data.datum.user.is_mobile_verified"
              class="text-danger"
            >(Awaiting activation)
            </span>
            <span
              v-else
            >(Active)
            </span>
          </div>
        </template>
        <template
          slot="category"
          slot-scope="slotProps"
        >
          <span
            v-if="slotProps && slotProps.data.datum.patientCareplan.length
              && slotProps.data.datum.patientCareplan[0].careplan
              && slotProps.data.datum.patientCareplan[0].careplan.category"
          >
            {{ slotProps.data.datum.patientCareplan[0].careplan.category.name }}
          </span>
          <span v-else>
            --
          </span>
        </template>
        <template
          slot="patientCareplan"
          slot-scope="slotProps"
        >
          <span v-if="slotProps">
            <div
              class="d-flex flex-column justify-content-between p-2"
              v-if="slotProps.data.datum.patientCareplan.length"
              v-b-tooltip.hover
              :title="slotProps.data.datum.patientCareplan[0].careplan.title"
            >
              <span
                class="btn-link"
                v-restrict
                @click="viewCarePlan(slotProps.data.datum.patientCareplan[0].careplan.id, true)"
              >
                {{ slotProps.data.datum.patientCareplan[0].careplan.title }}
              </span>
              <div v-if="slotProps.data.datum.patientCareplan[0] && slotProps.data.datum.patientCareplan[0].careplan.is_enrollment">
              <button
                v-if="permissions.patientlist.assign"
                class="btn btn-primary"
                @click="assignCareplan(slotProps.data.datum)"
              >
                Assign
              </button>
              <div v-if="slotProps.data.datum.pendingCarePlan">
                {{slotProps.data.datum.pendingCarePlan.careplan.title}}
                <span class="px-1 text-danger">(Pending)</span>
              </div>
            </div>
              <div v-else>
                <span
                  class="btn-link red"
                  @click="confirmAndUnAssignCareplan(slotProps.data.datum)"
                >
                  <i class="fa fa-times" />
                  Unassign
                </span>
              </div>
              
              <div class="d-flex flex-row justify-content-around pl-2 pr-2">
              </div>
            </div>
            <div v-else>
              <button
                v-if="permissions.patientlist.assign"
                class="btn btn-primary"
                @click="assignCareplan(slotProps.data.datum)"
              >
                Assign
              </button>
            </div>
          </span>
        </template>
      </v-table>
    </div>
    <b-modal
      id="modal-center"
      ref="planDurationRef"
      body-class="pt-0"
      centered
      title="Set plan duration for patient"
    >
      <div class="row">
        <div class="col col-md-12 col-12 position-fixed pl-3 pr-3 search-bar-content pt-2">
          {{ selectedCareplan.title }}<br>
           <span class="float-left">
             <b-badge>Plan Start Date: {{getFormattedDate(this.selectedCareplan.plan_start_date ,date)}}</b-badge>
          </span>
          <span class="float-right">
             <b-badge>Plan End Date: {{getFormattedDate(this.selectedCareplan.plan_end_date ,date)}}</b-badge>
          </span>
        </div>
        {{ selectedCareplan.plan_no || '' }} - {{ selectedCareplan.title }}
        <div class="col col-md-12 col-12 mt-5 carePlanCalendars">
          <div class="row">
            <div class="col col-lg-6 col-md-6 col-12 pt-2">
              <v-date-picker
                :minDate="this.planDuration.calStartDate"
                :maxDate=" this.selectedCareplan.plan_end_date"
                @onChange="onPlanDurationStartDateChange"
                label="Plan start date"
                :value="defaultDateFormat(planDuration.startDate)"
                v-validate="`required|earlier:${'Start date'},${planDuration.endDate}`"
                name="plan_start_date"
                :className="{'danger': errors.has('plan_start_date')}"
                position="bottom"
              />
            </div>
            <div class="col col-lg-6 col-md-6 col-12 pt-2">
              <v-date-picker
                :minDate="planDuration.startDate"
                :disabled="true"
                v-validate="`required|after:${'End date'},${planDuration.startDate}`"
                @onChange="value=> merge(planDuration, {endDate : value})"
                label="Plan End date"
                :value="defaultDateFormat(planDuration.endDate)"
                :className="{'danger': errors.has('plan_start_date')}"
                name="plan_start_date"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        slot="modal-footer"
        class="w-100"
      >
        <b-btn
          size="sm"
          class="float-right"
          variant="primary"
          @click="addCareplan"
          :disabled="this.disableAssignBtn"
        >
          Assign
        </b-btn>
        <b-btn
          size="sm"
          variant="outline-primary"
          class="float-right btn btn-outline-primary  mr-2"
          @click="onAssignCareplanCancel"
        >
          Cancel
        </b-btn>
      </div>
    </b-modal>
    <b-modal
      id="modal-center"
      ref="assignCareplanRef"
      body-class="pt-0"
      :footer-class="`display-none`"
      centered
      title="Assign care plan"
    >
      <div class="row">
        <div class="col col-md-12 col-12 position-fixed p-3 search-bar-content">
          <b-form-input
            v-model="carePlanSearchText"
            type="text"
            placeholder="Enter care plan name or ID"
            class="search-bar"
          />
        </div>
        <div class="col col-md-12 col-12 mt-70">
          <div
            v-if="(careplans &&
              !careplans.length || !careplans)
              && !careplanSearching"
            class="d-flex justify-content-center"
          >
            No Data found
          </div>
          <div
            v-for="careplan in careplans"
            :key="careplan.id"
            class="template"
            @click="setCurrentCareplan(careplan)"
          >
            <label
              v-restrict
              @click="viewCarePlan(careplan.id)"
            >
              <span class="btn-link">{{ careplan.title }}</span>
            </label>
            <p v-if="careplan.plan_no">
              {{ careplan.plan_no }}
            </p>
            <div class="template-detail">
              <span>Duration: {{ careplan.plan_duration }} days</span>
              <span>Prescriptions: {{ careplan.interventions }}</span>
              <span>Side Effects/Symptoms: {{ careplan.assessments }}</span>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <v-loader :isLoading="isPatientsLoading" />
  </v-layout>
</template>

<script>
import VTable from '@/components/table/index.vue';
import { mapGetters } from 'vuex';
import VLayout from '@/layouts/Default.vue';
import VLoader from '@/components/loader/index.vue';
import constants from '@/constants/app.properties';
import moment from 'moment';

export default {
  name: 'PatientList',
  components: {
    VTable,
    VLayout,
    VLoader
  },
  data() {
    return {
      patient: {},
      date: constants.MONTH_FIRST_DATE_FORMAT,
      isEnrollmentCareplan: false,
      selectedCareplan: {},
      disableAssignBtn: true,
      diffrence:30,
      statuses: {
        assigned: 'Assigned',
        unAssigned: 'UnAssigned',
        paused: 'Paused',
        stopped: 'Stopped'
      },
      carePlanSearchText: '',
      planDuration: {
        calStartDate:'',
        startDate: '',
        endDate: ''
      },
      filter: {
        status: 'all',
        searchValue: '',
        limit: 10,
        pageNo: 1
      },
      tableProps: {
        columns: [
          {
            headerCellProps: {
              class: 'header-cell'
            },
            cellProps: {
              class: 'text-left'
            },
            cellSlot: {
              name: 'patientName'
            },
            dataKey: 'name',
            dataType: String,
            label: 'Name'
          },
          {
            headerCellProps: {
              class: 'header-cell'
            },
            cellProps: {},
            dataKey: 'mr_id',
            dataType: String,
            label: 'ID'
          },
          {
            headerCellProps: {
              class: 'header-cell'
            },
            cellSlot: {
              name: 'category'
            },
            cellProps: {},
            defaultValue: '--',
            dataKey: 'category',
            dataType: String,
            label: 'Type'
          },
          {
            headerCellProps: {
              class: 'header-cell'
            },
            cellSlot: {
              name: 'status'
            },
            cellProps: {},
            dataKey: 'status',
            dataType: String,
            label: 'Status'
          },
          {
            headerCellProps: {
              class: 'header-cell'
            },
            cellProps: {},
            cellSlot: {
              name: 'patientCareplan'
            },
            disablePadding: false,
            label: 'Care Plan'
          }
        ],
        enableSelect: false,
        onPageChange: this.onPageChange,
        page: 1,
        rowProps: {},
        rowsPerPage: 10,
        title: 'PatientList'
      }
    };
  },
  computed: {
    ...mapGetters({
      patientList: 'patientList/getPatientList',
      patientStatusCount: 'patientList/getPatientStatusCount',
      loading: 'patientList/getLoading',
      careplanSearching: 'careplan/getSearching',
      totalCount: 'patientList/getTotalCount',
      careplans: 'careplan/getSearchedCareplans',
      permissions: 'auth/getModulePermissions',
      isPatientsLoading: 'patientList/getPatientListloading'
    })
  },
  watch: {
    filter: {
      handler: 'fetchPatients',
      immediate: true
    },
    carePlanSearchText: {
      handler: 'fetchCareplans',
      immediate: true
    }
  },
  methods: {
    onPageChange(pageNo, rowsPerPage) {
      this.tableProps.page = pageNo;
      this.filter = {
        ...this.filter,
        pageNo,
        limit: rowsPerPage
      };
    },
    onSearchText(event) {
      this.filter = {
        ...this.filter,
        pageNo:'1',
        searchValue: event.target.value
      };
    },
    fetchCareplans(searchValue) {
      const filter = {
        ...this.filter,
        searchValue
      };
      this.$store.dispatch('careplan/searchCarePlans', filter);
    },
    fetchPatients() {
      this.$store.dispatch('patientList/getPatients', this.filter);
    },
    assignCareplan(patient) {
      this.searchValue = '';
      this.patient = patient;
      this.isEnrollmentCareplan = patient.patientCareplan[0] && patient.patientCareplan[0].careplan && patient.patientCareplan[0].careplan.is_enrollment ? patient.patientCareplan[0].careplan.is_enrollment : false;
      this.$refs.assignCareplanRef.show();
    },
    addCareplan() {
      let selectedPlanStartDate = moment(this.planDuration.startDate).format('DD.MM.YYYY');
      let currentDate = moment().format('DD.MM.YYYY');
      selectedPlanStartDate = moment(selectedPlanStartDate,'DD.MM.YYYY');
      currentDate = moment(currentDate ,'DD.MM.YYYY');
      const diff = currentDate.diff(selectedPlanStartDate, 'days') + 1;
      const daysCountInOneCycle = this.selectedCareplan.plan_duration + this.selectedCareplan.break_time;
      let applicableDate = '';
      let currentCycle = 0;
      let status = '';
      if (diff > 1) {
          currentCycle = Math.ceil(diff/daysCountInOneCycle);
          let currentDays = diff%daysCountInOneCycle;
          applicableDate = moment(selectedPlanStartDate, 'YYYY-MM-DD').add((currentCycle-1)*(daysCountInOneCycle)+1, 'days');
          if (currentDays > this.selectedCareplan.plan_duration || (currentDays === 0 && this.selectedCareplan.break_time !== 0)) {
            status = 'inBreakTime';
            applicableDate = moment(applicableDate, 'YYYY-MM-DD').add(daysCountInOneCycle, 'days');
          } else {
            status = 'notInBreakTime';
            if (diff === 1 && currentCycle === 1 && this.selectedCareplan.plan_duration === 1 && this.selectedCareplan.break_time === 0) {
              currentCycle = 2;
            } else if (currentCycle === 1 && currentDays !== 0) {
              status = 'valid';
            } else {
              status = 'notInBreakTime';
            }
          }
          applicableDate = moment(applicableDate, 'YYYY-MM-DD').subtract(1, 'days');
          applicableDate = moment(applicableDate).format('YYYY-MM-DD');
          this.onPlanDurationStartDateChange(applicableDate);
      } else {
        status = 'valid';
      }
      this.confirmAndAssignCareplan(applicableDate, status, currentCycle);
      this.$refs.planDurationRef.hide();
    },
    onAssignCareplanCancel() {
      this.$refs.planDurationRef.hide();
    },
    onControlClick(type, id) {
      if (type === 'Delete') {
        const data = { is_active: false };
        this.$store.dispatch('patientList/remove', { data, id });
      }
    },
    setCurrentCareplan(plan) {
      this.selectedCareplan = plan;
      this.$refs.planDurationRef.show();
      
      var selectedPlanStartDate = moment(this.selectedCareplan.plan_start_date).format('DD.MM.YYYY');
      var currentDate = moment().format('DD.MM.YYYY');
      selectedPlanStartDate = moment(selectedPlanStartDate,'DD.MM.YYYY');
      currentDate = moment(currentDate ,'DD.MM.YYYY');
      var diff = selectedPlanStartDate.diff(currentDate, 'days');
      if(diff < 0){
        if(Math.abs(diff) <= 30){
           this.diffrence = Math.abs(diff)
        } 
        // else{
        //   this.diffrence = 30;
        // }
      } 
      this.planDuration.calStartDate =  moment().subtract(this.diffrence,'d').format('YYYY-MM-DD');
    },
    confirmAndAssignCareplan(applicableDate, status, currentCycle) {
      let content = {
        title: 'Are you sure ?',
        message: `Would you like to assign this care plan ${
          this.selectedCareplan.plan_no
        } 
        to ${this.patient.user.first_name} ${this.patient.user.last_name}?`
      };
      const date =  moment(applicableDate).format(constants.MONTH_FIRST_DATE_FORMAT);
      if (status === 'notInBreakTime') {
        content.message = `This patient has already completed ${currentCycle-1} cycle(s) and now in the cycle ${currentCycle}, which started on ${date}. Hence resetting the Plan Start date to ${date}`
      } else if (status === 'inBreakTime') {
        content.message = `This patient has already completed ${currentCycle} cycle(s) and now in the Break period. The next cycle will start on ${date}. Hence resetting the Plan Start date to ${date}`
      }
      this.conFirmAlert(
        content,
        () => {
          const data = {
            carePlanId: this.selectedCareplan.id,
            patientId: this.patient.id,
            startDate: this.planDuration.startDate,
            endDate: this.planDuration.endDate
          };
          const formData = {data, isEnrollmentCareplan: this.isEnrollmentCareplan, filter: this.filter};
          this.$store.dispatch('patientList/assignCareplan', formData);
          this.$refs.assignCareplanRef.hide();
        },
        () => {
          this.selectedCareplan = {};
          this.planDuration = {
            startDate: '',
            endDate: ''
          };
        }
      );
    },
    confirmAndUnAssignCareplan(patient) {
      const plan = patient.patientCareplan[0].careplan;
      const content = {
        title: `UnAssign care plan ${plan.title}`,
        message: `Do you want to un assign this user (${
          patient.user.first_name
        } ${patient.user.last_name})?`
      };
      this.conFirmAlert(
        content,
        () => {
          const data = {
            carePlanId: plan.id,
            patientId: patient.id
          };
          this.$store.dispatch('patientList/unAssignCareplan', {data, filter: this.filter});
        },
        () => {
          this.selectedCareplan = {};
          this.planDuration = {
            startDate: '',
            endDate: ''
          };
        }
      );
    },
    editPatient(id) {
      this.$router.push({
        name: 'patientList.edit',
        params: { id }
      });
    },
    viewCarePlan(id, isSelf) {
      const routeData = this.$router.resolve({
        name: 'careplan.view',
        params: { id }
      });
      window.open(routeData.href, isSelf ? '_self' : '_blank');
    },
    viewEHR(id) {
      this.$router.push({
        name: 'patientList.view',
        params: { id }
      });
    },
    setStatus(currentStatus) {
      if (this.filter.status !== currentStatus) {
        this.filter = {
          ...this.filter,
          status: currentStatus
        };
      }
    },
    onPlanDurationStartDateChange(value) {
      this.disableAssignBtn = true;
      this.planDuration = this.merge(this.planDuration, {
        startDate: value,
        endDate: this.addDays(value, ( ((this.selectedCareplan.plan_duration * this.selectedCareplan.cycles ) 
        + (this.selectedCareplan.break_time *(this.selectedCareplan.cycles -1)) )-1 ))
      });
      if (this.selectedCareplan.cycles === 1500) {
        this.planDuration.endDate = this.selectedCareplan.plan_end_date;
      }
      if(this.planDuration.endDate <= this.selectedCareplan.plan_end_date){
        this.disableAssignBtn = false;
      }
    },

    redirectToMessage(mrId) {
      const data = { mrId, isSelectedPatient: true };
      this.$store.dispatch('patient/setPatientDataToMsg', data);
      this.$router.push({ name: 'message.index' });
    },
    addPatient() {
      this.$router.push({
        name: 'patient.create'
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
